import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { useTopicPage_DeleteLabeMutation } from "sprout-graphql";
import { EmptyListText } from "@sprout/client-components/dist/EmptyList";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { getItemUrl } from "sprout-lib";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import { useHistory } from "react-router-dom";
import TopicPageHeader from "../TopicPageHeader";
import TopicPageViewsLabelPosts from "./TopicPageViewsLabelPosts";
const TopicPageViewsLabelMain = (props)=>{
    const { topic , label , posts , updateList  } = props;
    const { rootTopicOrSelf  } = topic;
    const { owner  } = rootTopicOrSelf || {};
    const history = useHistory();
    const labelId = label.id;
    const showSnackbar = useSnackbar();
    const [deleteLabel] = useTopicPage_DeleteLabeMutation();
    useActionRegistryGlobalHandler("PAGE_DELETE", useCallback(()=>{
        deleteLabel({
            variables: {
                labelId
            }
        }).then(()=>{
            showSnackbar({
                message: "Label deleted"
            });
            history.replace(getItemUrl(topic, owner));
        }).catch(()=>{
            showSnackbar.error();
        });
        return true;
    }, [
        deleteLabel,
        labelId,
        history,
        topic,
        owner,
        showSnackbar
    ]));
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TopicPageHeader, {
                topic: topic,
                label: label
            }),
            posts.length === 0 && /*#__PURE__*/ _jsxs(EmptyListText, {
                children: [
                    "Need to categorize leaves for easy reference? To label a leaf, select a leaf and tap ",
                    /*#__PURE__*/ _jsx("em", {
                        children: "Label"
                    }),
                    "."
                ]
            }),
            posts.length !== 0 && /*#__PURE__*/ _jsx(TopicPageViewsLabelPosts, {
                posts: posts,
                updateList: updateList
            })
        ]
    });
};
export default TopicPageViewsLabelMain;
